import React, { useMemo } from "react";
import ReactApexChart from "react-apexcharts";

const AreaChart = ({ dashboardData, displayValue }) => {
  const chartOptions = useMemo(() => {
    const labelArr = [];
    const seriesRevenueArr = [];
    const seriesExpertPayoutsArr = [];
    const seriesServiceRevenueArr = [];

    if (dashboardData?.byOrder?.length) {
      dashboardData.byOrder.forEach((item) => {
        console.log("item", item);
        // Use a fallback for dayOfWeek if it’s null
        if (displayValue) {
          labelArr.push(item[displayValue] || "N/A");
        } else {
          labelArr.push(item.dayOfWeek || item.date || "N/A");
        }
        seriesRevenueArr.push(item.revenueTotal || 0);
        seriesExpertPayoutsArr.push(item.expertPayoutTotal || 0);
        seriesServiceRevenueArr.push(item.serviceRevenueTotal || 0);
      });
    }

    return {
      series: [
        {
          name: "Gross Revenue",
          data: seriesRevenueArr,
        },
        {
          name: "Therapist Payouts",
          data: seriesExpertPayoutsArr,
        },
        {
          name: "Service Revenue",
          data: seriesServiceRevenueArr,
        },
      ],
      options: {
        chart: {
          type: "area",
          height: 350,
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },
        labels: labelArr,
        yaxis: {
          opposite: false,
        },
        legend: {
          horizontalAlign: "left",
        },
      },
    };
  }, [dashboardData?.byOrder]);

  return (
    <div>
      <div id="chart">
        {chartOptions.series[0].data.length > 0 ? ( // Check if there's data to render
          <ReactApexChart
            options={chartOptions.options}
            series={chartOptions.series}
            type="area"
            height={350}
          />
        ) : (
          <p>No data available for the chart.</p>
        )}
      </div>
      <div id="html-dist"></div>
    </div>
  );
};

export default AreaChart;
